import React from 'react';
import { cloneDeep } from 'lodash';
import SelectCount from '../Partials/SelectCount';
import Hours from '../Partials/Hours';
import PriceConditions from '../Partials/PriceConditions';

function Step1({ minDate, date, onDateChange, hour, onHourChange, equipmentsToTrail = [], slots = [], equipments, onEquipmentsChange, hideTitle = false, showHoursDetails = false, hoursType = "button", pricing,
showAllConditions = false }) {
    const equipmentChange = (equipmentToTrailId, equipmentId, count) => {
        const newEquipmentsToTrail = cloneDeep(equipments);
        const index = newEquipmentsToTrail.findIndex(
            (x) => x.equipmentToTrailId === equipmentToTrailId,
        );

        if (index > -1) {
            newEquipmentsToTrail[index].count = count;
            newEquipmentsToTrail[index].id = equipmentId;
        } else {
            newEquipmentsToTrail.push({
                equipmentToTrailId,
                count,
                id: equipmentId,
            });
        }
        onEquipmentsChange(newEquipmentsToTrail.filter((x) => x.count));
    };
    // console.log(pricing);
    return (
        <section className="step">
            {!hideTitle && (
                <div className="mb-4">
                    <h5 className="widget-title text-center">
                        Krok 1/3: Parametry spływu
                    </h5>
                    <div className="progress" style={{ height: '8px' }}>
                        <div
                            className="progress-bar position-relative bg-primary"
                            style={{ width: '33%' }}
                        ></div>
                    </div>
                </div>
            )}

            <div className="form-group mb-3">
                <label htmlFor="date" className="form-label">
                    Data spływu <span className="text-danger">*</span>
                </label>
                <input
                    name="date"
                    type="date"
                    className="form-control mb-2"
                    min={minDate}
                    value={date}
                    onChange={(e) => onDateChange(e.target.value)}
                />
                <small className="text-muted">
                    Ceny i dostępności mogą się zmienić w zależności od
                    wybranego dnia, godziny i liczby pozycji.
                </small>
            </div>

            <div>
                {/* <h5 className="">Kajaki</h5> */}
                {equipmentsToTrail.map((equipmentToTrail) => (
                    <SelectCount
                        key={equipmentToTrail.id}
                        equipmentToTrail={equipmentToTrail}
                        slots={slots}
                        hour={hour}
                        value={
                            equipments.find(
                                (x) =>
                                    x.equipmentToTrailId ===
                                    equipmentToTrail.id,
                            )?.count || 0
                        }
                        onChange={equipmentChange}
                        pricing={pricing.equipments?.find(
                            (x) => x.equipmentToTrailId === equipmentToTrail.id,
                        )}
                    />
                ))}
                <p>
                    <small className="text-muted">
                        Po wybraniu liczby pozycji, dostępne godziny zostaną
                        zaktualizowane.
                    </small>
                </p>

                {/* {!equipments.length 
          ? <p className="alert alert-danger" role="alert" style={{ margin: '20px 0' }}>Nie wybrano żadnej pozycji.</p> 
          : null} */}
            </div>

            {/* available hours */}
            <Hours
                slots={slots}
                onHourChange={onHourChange}
                equipments={equipments}
                hour={hour}
                showDetails={showHoursDetails}
                type={hoursType}
            />

            <PriceConditions showAll={showAllConditions} pricing={pricing} />

            {/*
        <app-discount-messages :conditions="conditions"></app-discount-messages>
      */}
        </section>
    );
}

export default Step1;